import { RadioGroup, Stack } from "@mui/material"
import { ChangeEvent } from "react"
import "./styles.scss"
import { Icon, Typography, Radio } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"

export const OptInPolicy = ({ initIsDOptIn, onChange }: { initIsDOptIn: boolean, onChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void }) => {
    const { t } = useTranslation()

    return <RadioGroup defaultValue={initIsDOptIn ? "dOptIn" : "optIn"} onChange={onChange} className="optInPolicy-component">
        <Stack gap={2} className="doubleOptInPolicy" justifyItems="center">
            <Stack direction="row" gap={2} alignItems="center">
                <Radio value="dOptIn" color="secondary" size="small" />
                <Typography variant="body1L">{t("general-double-opt-in")}({t("general-recommended")})</Typography>
            </Stack>
            <Typography variant="body2S" className="desc">{t("list-dopt-in-policy-desc")}</Typography>
            <Stack direction="row" gap={2} alignItems="center">
                <Icon name="Checkmark14" color="secondary" />
                <Typography variant="body1">{t("list-dopt-in-policy-gain-1")}</Typography>
            </Stack>
            <Stack direction="row" gap={2} alignItems="center">
                <Icon name="Checkmark14" color="secondary" />
                <Typography variant="body1">{t("list-dopt-in-policy-gain-2")}</Typography>
            </Stack>
            <Stack direction="row" gap={2} alignItems="center">
                <Icon name="Checkmark14" color="secondary" />
                <Typography variant="body1">{t("list-dopt-in-policy-gain-3")}</Typography>
            </Stack>
        </Stack>
        <Stack direction="row" gap={2} className="optInPolicy" alignItems="center">
            <Radio value="optIn" color="secondary" size="small" />
            <Typography variant="body1L" className="semiBold">{t("general-single-opt-in")}</Typography>
        </Stack>
    </RadioGroup>
}